import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import "./EcourseEmptyContent.style";

class EcourseEmptyContent extends PolymerElement {
  static get template() {
    return html`
      <style include="ecourse-empty-content-style"></style>
      <div class="container">
        <h3>{{title}}</h3>
        <p>{{description}}</p>
        <template is="dom-if" if="{{!isLogin}}">
            <div on-click="_handleLogin" class="button-login">Masuk atau Daftar Alomedika</div>
        </template
      </div>
    `;
  }

  static get properties() {
    return {
      title: {
        type: String,
      },
      description: {
        type: String,
      },
      isLogin: {
        type: Boolean,
        value: false,
      },
    };
  }

  _handleLogin() {
    $("#entrance-overlay").css("display", "block");
  }
}
customElements.define("ecourse-empty-content", EcourseEmptyContent);
